var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilledHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7896 7.89095L8.35366 1.4597C8.30732 1.41327 8.25228 1.37644 8.19169 1.3513C8.13109 1.32617 8.06614 1.31323 8.00054 1.31323C7.93494 1.31323 7.86998 1.32617 7.80939 1.3513C7.74879 1.37644 7.69375 1.41327 7.64741 1.4597L1.21147 7.89095C1.02397 8.07845 0.917725 8.33314 0.917725 8.59877C0.917725 9.15033 1.36616 9.59877 1.91772 9.59877H2.59585V14.1878C2.59585 14.4644 2.81929 14.6878 3.09585 14.6878H7.00054V11.1878H8.75054V14.6878H12.9052C13.1818 14.6878 13.4052 14.4644 13.4052 14.1878V9.59877H14.0833C14.349 9.59877 14.6037 9.49408 14.7912 9.30502C15.1802 8.91439 15.1802 8.28158 14.7896 7.89095Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHome);
export default __webpack_public_path__ + "static/media/filled-home.2ca0093cfac3a51efdb3aabc53263c51.svg";
export { ForwardRef as ReactComponent };